// src/components/InvestorEngagementPage.jsx
import React from "react";
// import "./InvestorEngagementPage.scss";

const InvestorEngagementPage = () => {
  return (
    <div className="investor-engagement">
      <h2>Engage Your Investors</h2>
      <div>
        <h3>Perks & Utilities</h3>
        <p>Exclusive perks for token holders will appear here.</p>
      </div>
      <div>
        <h3>Community Updates</h3>
        <p>Latest updates and announcements.</p>
      </div>
      <div>
        <h3>Voting System</h3>
        <p>Enable community decision-making for key milestones.</p>
      </div>
    </div>
  );
};

export default InvestorEngagementPage;
